export const AXIOS_REQ_TIMEOUT = 7 * 60 * 1000; // milli-seconds
export const LOADING_MESSAGE_DURATION = 7 * 60; // seconds
export const DEFAULT_MESSAGE_DURATION = 5; //seconds
